import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'


import BannerFaq from '../../components/Carousel/BannerFaq'
import FaqGekas from '../../components/Sections/FaqGekas'

const Faq = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >

      <Header />
      <BannerFaq />

     
  
      <FaqGekas/>
  
     
      <Footer />
    </motion.div>
  )
}

export default Faq
